//@ts-nocheck

import {useRouter} from 'next/navigation';
import Avatar from '@delorand/ui/src/radix/avatar';
import {ChevronRightSvg} from '@delorand/ui/src/svg/shared';
import {useUser} from 'c/utils/hooks';
import TimeAgo from 'react-timeago';
import NewGroup from './new-group';

function GroupCart() {
  const router = useRouter();
  const [userdata] = useUser();

  return (
    <div className="mt-7 flex w-full flex-col items-center">
      {!!userdata ? (
        <>
          {userdata.groupCarts.length < 1 && (
            <NewGroup
              userdata={userdata}
              children={
                <span className="btn-white">
                  {userdata.groupCarts.length > 0 ? 'Add Group' : 'Get Started'}
                </span>
              }
            />
          )}
          <GroupList userdata={userdata} />
        </>
      ) : (
        <>
          <p className="text-lg">Shop Together, Stay in the flow! </p>
          <button
            type="button"
            className="btn-white mt-5"
            onClick={() => router.push('/login')}
          >
            Log-In
          </button>
        </>
      )}
    </div>
  );
}

const GroupList = ({
  userdata,
}: {
  userdata: NonNullable<CartReturn['userdata']>;
}) => {
  const router = useRouter();
  const getUserName = (id: string) =>
    userdata.friendTo?.find(x => x.id === id)?.userName;

  return (
    <div className="my-3 flex w-full flex-col gap-3 px-3">
      {userdata.groupCarts.map(group => (
        <div key={group.id} className="flex w-full items-center gap-3">
          <Avatar className="h-10 w-10 rounded-full" src={group.image} />
          <div className="flex-1">
            <div
              className="flex items-center gap-3"
              onClick={() => router.push(`/cart/${group.id}`)}
            >
              <h4 className="flex-1 text-sm font-semibold">{group.name}</h4>
              <TimeAgo
                className="text-xs text-neutral-300"
                date={group.createdAt}
              />
            </div>
            <h5 className="mt-1 w-fit rounded-lg bg-white/15 px-3 py-0.5 text-xs">
              {group.members
                .filter(x => x.id !== userdata.id)
                .slice(0, 2)
                .map(member => getUserName(member.id))
                .join(',')}
              {group.members.length - 1 > 1 &&
                `and ${group.members.length - 2} others`}
            </h5>
          </div>
          <ChevronRightSvg />
        </div>
      ))}
    </div>
  );
};

export default GroupCart;
